import React, { useState } from 'react'
import { Button } from '@sketch/components'

import { useConsolidateAutoVersionMutation } from '@sketch/gql-types'

export interface ConsolidateVersionButtonProps {
  shareIdentifier: string
}

export const ConsolidateVersionButton = ({
  shareIdentifier,
}: ConsolidateVersionButtonProps) => {
  const [isConsolidating, setIsConsolidating] = useState(false)

  const [consolidateShare] = useConsolidateAutoVersionMutation({
    variables: {
      shareIdentifier,
    },
    onError: 'show-toast',
  })

  const doConsolidate = async () => {
    setIsConsolidating(true)
    consolidateShare()
  }

  return (
    <Button
      onClick={doConsolidate}
      loading={isConsolidating}
      variant="primary"
      size="32"
      data-testid="consolidate-pending-button"
    >
      {isConsolidating ? '–' : 'See Latest Version'}
    </Button>
  )
}
